import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { THTransaction, TransactionDetail } from 'src/app/interfaces/api/transaction';
import { ProductToReview } from 'src/app/pages/product-rating/product-rating.page';
import { TransactionService } from 'src/app/services/transaction.service';
import { encodeQueryParam } from 'src/helpers';

@Component({
  selector: 'app-order-products',
  templateUrl: './order-products.component.html',
  styleUrls: ['./order-products.component.scss'],
})
export class OrderProductsComponent implements OnInit {
  @Input() transactionDetail: TransactionDetail;
  @Input() orderId: number;
  @Input() isLoading = false;
  orderDetail: THTransaction;

  constructor(private router: Router, private transactionService: TransactionService) {}

  ngOnInit() {
    if (this.isLoading) {
      return;
    }

    this.loadData(null);
  }

  loadData(event: any) {
    const transactionDetailReq = this.transactionService.getSingleTransaction(this.orderId);

    forkJoin([transactionDetailReq]).subscribe({
      next: async ([transactionDetailRes]) => {
        this.orderDetail = transactionDetailRes.transaction;
        // console.log(this.orderDetail);
      },
      complete: () => {
        event?.target?.complete();
      },
    });
  }

  reviewProduct(
    event: Event,
    transactionId: number,
    transactionProductId: number,
    productId: number,
    transactionCode: string,
  ) {
    event.stopPropagation();

    const productsToReview: ProductToReview[] = [];

    productsToReview.push({
      productId,
      transactionProductId,
      transactionCode,
      transactionId,
    });

    this.router.navigate(['/product-rating'], {
      queryParams: {
        productsToReview: encodeQueryParam(productsToReview),
      },
    });
  }

  viewReviewedProduct(event: Event, productId: number) {
    event.stopPropagation();

    this.router.navigate([`/product-reviews/${productId}`]);
  }

  goToProductDetailPage(productId: number, warehouseId: number) {
    // if (this.orderDetail?.status !== 1) {
    //   return;
    // }

    this.router.navigate(['product-detail', productId], {
      queryParams: {
        selectedWarehouseId: encodeQueryParam(warehouseId),
      },
    });
  }

  toNumber(str: string) {
    return Number(str);
  }
}
